<app-error-dialog
  [titleKey]="view.titleKey"
  [messageKey]="view.bodyKey"
  [reasons]="view.reasonKeys"
  [instructionKey]="view.instructionKey"
  [primaryActionLabelKey]="view.primaryLabelKey"
  [secondaryActionLabelKey]="view.secondaryLabelKey"
  (primaryAction)="onPrimary()"
  (secondaryAction)="onSecondary()"
  (dismissed)="onCancel()"
/>
